/* eslint-disable react/prop-types */
// import cx from 'classnames';
import * as dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
// import { ICON_MAP } from '@constants/img';
// import request from '@api';
import classes from './TabPanel.module.css';
import { TransactionStatus } from './TransactionStatus';
// import { formatTime } from '../../utils';

dayjs.extend(utc);
dayjs.extend(timezone);
const NONE_VALUE = '--';
const DETAIL_STATUS = 'successed';
/**
 * 获取保留2位小数的精确数字
 * @param {Number} value 原始数字
 * @param {String} prefix 前缀
 * @returns {String}
 */
// const getAccurateValue = (value, prefix = '') => {
//   if (!value) {
//     return '';
//   }
//   return `${prefix} ${Number(value).toFixed(2)}`;
// };

const TransactionCell = ({ children }) => (
  <div className={classes.transaction_cell}>{children}</div>
);

// const TransactionTypeCell = ({ type, flow }) => (
//   <div className={classes.transaction_type}>
//     <div className={cx({ [classes.transaction_type_dot]: true, [classes.transaction_type_dot_blue]: flow === 'charge' })} />
//     {type}
//   </div>
// );

const handleDownload = async ({ settleBillId }, settleType) => {
  window.open(`https://${process.env.API_HOSTNAME}/gateway/merchant-service/api/open-platform/billing/download-trans-detail-list?settleBillId=${settleBillId}&settleType=${settleType}`);

  // const blob = await request('billing/download-trans-detail-list', {
  //   path: '/gateway/merchant-service/api/open-platform/',
  //   method: 'POST',
  //   // headers: { 'Content-Type': 'text/csv;chatset=UTF-8' },
  //   body: { settleBillId, settleType },
  //   download: true,
  // }, {
  // }).then((res) => res);
  // console.log('blob', blob);
  // const blobURL = URL.createObjectURL(blob);

  // // 创建a标签触发下载
  // const link = document.createElement('a');
  // link.href = blobURL;
  // link.download = `data-${billingCycle}.csv`;

  // document.body.appendChild(link);
  // link.click();
  // document.body.removeChild(link);
};

const handleClickInvoice = (url) => {
  console.log('handleClickInvoice');
  window.open(url);
};

const ColumnConfig = {
  Amount: (minWidth) => ({
    id: 'amount',
    label: 'Reimbursement amount',
    minWidth,
    format: (val, { payableList }) => {
      const {
        amount,
      } = payableList[0] || {};
      return (
        <TransactionCell>
          {amount || NONE_VALUE}
        </TransactionCell>
      );
    },
  }),
  Status: (minWidth) => ({
    id: 'status',
    label: 'Status',
    minWidth,
    format: (val, { payableList }) => {
      console.log(payableList);
      const { time, status } = payableList[0] || {};

      return (
        <section className={classes.flex_cell}>
          <TransactionStatus status={status === DETAIL_STATUS ? 'Paid' : 'Unpaid'} />
          {time}
        </section>
      );
    },
  }),

  BillingCycle: (minWidth) => ({
    id: 'billingCycle',
    label: 'Billing cycle',
    minWidth,
  }),
  BillingDate: (minWidth) => ({
    id: 'billingDate',
    label: 'Billing date',
    minWidth,
  }),
  PremiumsOwed: (minWidth) => ({
    id: 'Premiums owed',
    label: 'Premiums owed',
    minWidth,
    format: (val, { receivableList }) => {
      const {
        amount, time, status,
      } = receivableList[0] || {};
      return (
        <TransactionCell>
          {amount}
          <div className={classes.flex_cell}>
            <TransactionStatus status={status === DETAIL_STATUS ? 'Paid' : 'Unpaid'} />
            {time}
          </div>
        </TransactionCell>
      );
    },
  }),
  PremiumsRefunded: (minWidth) => ({
    id: 'Premiums refunded',
    label: 'Premiums refunded',
    labelTip: (
      <div>
        Premiums refunded are refunds due to policy cancelation. These premiums are refunded to the billing cycle when policies were created. Depending on the billing status, there might be 2 refund statuses:
        <br />
        <br />
        <span className={classes.bold}>Refunded: </span>
        This refund has already been credited to this invoice.
        <br />
        <br />
        <span className={classes.bold}>To be refunded: </span>
        Premiums for this billing cycle are still awaiting payment. We will promptly refund you for the canceled premiums once payment is made.
      </div>
    ),
    minWidth,
    format: (val, {
      refundableList,
    }) => {
      if (!refundableList?.length) {
        return NONE_VALUE;
      }

      return (
        <TransactionCell>
          {refundableList.map(({
            amount, status, time, receivableCycleDate, refundableCycleDate,
          }) => {
            const tooltip = status === DETAIL_STATUS ? (
              `Some policies created during ${receivableCycleDate} 

              have been cancelled during ${refundableCycleDate}.`
            ) : (
              <div>
                {`Some policies created during ${receivableCycleDate}
          have been cancelled${refundableCycleDate ? ` during ${refundableCycleDate}` : ''}. `}
                <br />
                <br />
                Premiums will be refunded once payment for that cycle is made.
              </div>
            );
            return (
              <div className={classes.cell_refund_item}>
                {amount}
                <div className={classes.flex_cell}>
                  <TransactionStatus status={status === DETAIL_STATUS ? 'Refunded' : 'To be refunded'} tooltip={tooltip} style={{ cursor: 'pointer' }} />
                  {time}
                </div>
              </div>
            );
          })}
        </TransactionCell>
      );
    },
  }),
  Action: (minWidth, tab) => ({
    id: 'action',
    label: 'Action',
    minWidth,
    // align: 'right',
    format: (val, rows) => (
      <TransactionCell>
        <div className={classes.actions}>
          <span onClick={() => handleDownload(rows, tab ? 'receivable' : 'payable')}>Download details</span>
          {tab && <span onClick={() => handleClickInvoice(rows.receivabeInvoiceUrl)}>Invoice</span>}
        </div>
      </TransactionCell>
    ),
  }),
};

export const columns = [
  ColumnConfig.BillingCycle(100),
  ColumnConfig.Amount(140),
  ColumnConfig.Status(140),
  ColumnConfig.Action(140),
];
export const paymentsColumns = [
  ColumnConfig.BillingCycle(100),
  ColumnConfig.BillingDate(200),
  ColumnConfig.PremiumsOwed(240),
  ColumnConfig.PremiumsRefunded(240),
  ColumnConfig.Action(140, true),
];
